module.exports = __webpack_public_path__ + "img/厨房电器2.118c2de6.jpg";